"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _gAxios = _interopRequireWildcard(require("@gravity/g-axios"));
var _utils = require("@gravity/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_ox2ey727x() {
  var path = "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/catalog/lib/actions.js";
  var hash = "006c50ccd344ca62302a9fb03c0b1ba30f1e8af7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/catalog/lib/actions.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 28
        },
        end: {
          line: 6,
          column: 2
        }
      },
      "1": {
        start: {
          line: 4,
          column: 35
        },
        end: {
          line: 6,
          column: 1
        }
      },
      "2": {
        start: {
          line: 8,
          column: 29
        },
        end: {
          line: 12,
          column: 2
        }
      },
      "3": {
        start: {
          line: 8,
          column: 48
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "4": {
        start: {
          line: 14,
          column: 37
        },
        end: {
          line: 18,
          column: 2
        }
      },
      "5": {
        start: {
          line: 14,
          column: 56
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "6": {
        start: {
          line: 20,
          column: 27
        },
        end: {
          line: 22,
          column: 2
        }
      },
      "7": {
        start: {
          line: 20,
          column: 34
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "8": {
        start: {
          line: 24,
          column: 13
        },
        end: {
          line: 63,
          column: 1
        }
      },
      "9": {
        start: {
          line: 24,
          column: 79
        },
        end: {
          line: 63,
          column: 1
        }
      },
      "10": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 26,
          column: 34
        }
      },
      "11": {
        start: {
          line: 27,
          column: 15
        },
        end: {
          line: 34,
          column: 3
        }
      },
      "12": {
        start: {
          line: 35,
          column: 16
        },
        end: {
          line: 35,
          column: 112
        }
      },
      "13": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 39,
          column: 3
        }
      },
      "14": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 16
        }
      },
      "15": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 53
        }
      },
      "16": {
        start: {
          line: 40,
          column: 21
        },
        end: {
          line: 40,
          column: 46
        }
      },
      "17": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 62,
          column: 7
        }
      },
      "18": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 55,
          column: 7
        }
      },
      "19": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 52,
          column: 9
        }
      },
      "20": {
        start: {
          line: 48,
          column: 10
        },
        end: {
          line: 48,
          column: 61
        }
      },
      "21": {
        start: {
          line: 51,
          column: 10
        },
        end: {
          line: 51,
          column: 53
        }
      },
      "22": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 53,
          column: 61
        }
      },
      "23": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 54,
          column: 29
        }
      },
      "24": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 21
        }
      },
      "25": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 37
        }
      },
      "26": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 102
        }
      },
      "27": {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 28
          },
          end: {
            line: 4,
            column: 29
          }
        },
        loc: {
          start: {
            line: 4,
            column: 35
          },
          end: {
            line: 6,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 29
          },
          end: {
            line: 8,
            column: 30
          }
        },
        loc: {
          start: {
            line: 8,
            column: 48
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 37
          },
          end: {
            line: 14,
            column: 38
          }
        },
        loc: {
          start: {
            line: 14,
            column: 56
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 14
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 27
          },
          end: {
            line: 20,
            column: 28
          }
        },
        loc: {
          start: {
            line: 20,
            column: 34
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 24,
            column: 13
          },
          end: {
            line: 24,
            column: 14
          }
        },
        loc: {
          start: {
            line: 24,
            column: 79
          },
          end: {
            line: 63,
            column: 1
          }
        },
        line: 24
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 24,
            column: 79
          },
          end: {
            line: 24,
            column: 80
          }
        },
        loc: {
          start: {
            line: 24,
            column: 91
          },
          end: {
            line: 63,
            column: 1
          }
        },
        line: 24
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 43,
            column: 10
          },
          end: {
            line: 43,
            column: 11
          }
        },
        loc: {
          start: {
            line: 43,
            column: 22
          },
          end: {
            line: 57,
            column: 5
          }
        },
        line: 43
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 58,
            column: 11
          },
          end: {
            line: 58,
            column: 12
          }
        },
        loc: {
          start: {
            line: 58,
            column: 23
          },
          end: {
            line: 62,
            column: 5
          }
        },
        line: 58
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 24
          },
          end: {
            line: 24,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 24,
            column: 32
          },
          end: {
            line: 24,
            column: 37
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 35,
            column: 41
          },
          end: {
            line: 35,
            column: 103
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 35,
            column: 89
          },
          end: {
            line: 35,
            column: 98
          }
        }, {
          start: {
            line: 35,
            column: 101
          },
          end: {
            line: 35,
            column: 103
          }
        }],
        line: 35
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 41
          },
          end: {
            line: 35,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 41
          },
          end: {
            line: 35,
            column: 54
          }
        }, {
          start: {
            line: 35,
            column: 58
          },
          end: {
            line: 35,
            column: 86
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 36,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 36,
            column: 19
          }
        }, {
          start: {
            line: 36,
            column: 23
          },
          end: {
            line: 36,
            column: 57
          }
        }],
        line: 36
      },
      "5": {
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 55,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 55,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 44
      },
      "6": {
        loc: {
          start: {
            line: 44,
            column: 10
          },
          end: {
            line: 44,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 10
          },
          end: {
            line: 44,
            column: 32
          }
        }, {
          start: {
            line: 44,
            column: 36
          },
          end: {
            line: 44,
            column: 57
          }
        }],
        line: 44
      },
      "7": {
        loc: {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 52,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 52,
            column: 9
          }
        }, {
          start: {
            line: 49,
            column: 15
          },
          end: {
            line: 52,
            column: 9
          }
        }],
        line: 47
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "006c50ccd344ca62302a9fb03c0b1ba30f1e8af7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ox2ey727x = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ox2ey727x();
cov_ox2ey727x().s[0]++;
var getBeforeLoadAction = function getBeforeLoadAction() {
  cov_ox2ey727x().f[0]++;
  cov_ox2ey727x().s[1]++;
  return {
    type: 'CATALOG_BEFORE_LOAD'
  };
};
cov_ox2ey727x().s[2]++;
var getLoadSuccessAction = function getLoadSuccessAction(data, config) {
  cov_ox2ey727x().f[1]++;
  cov_ox2ey727x().s[3]++;
  return {
    type: 'CATALOG_LOAD_SUCCESS',
    data: data,
    config: config
  };
};
cov_ox2ey727x().s[4]++;
var getLoadCalendarSuccessAction = function getLoadCalendarSuccessAction(data, config) {
  cov_ox2ey727x().f[2]++;
  cov_ox2ey727x().s[5]++;
  return {
    type: 'CATALOG_CALENDAR_LOAD_SUCCESS',
    data: data,
    config: config
  };
};
cov_ox2ey727x().s[6]++;
var getLoadErrorAction = function getLoadErrorAction() {
  cov_ox2ey727x().f[3]++;
  cov_ox2ey727x().s[7]++;
  return {
    type: 'CATALOG_LOAD_ERROR'
  };
};
cov_ox2ey727x().s[8]++;
var load = function load(config, _ref) {
  var _ref$byDay = _ref.byDay,
    byDay = _ref$byDay === void 0 ? (cov_ox2ey727x().b[0][0]++, false) : _ref$byDay,
    maxOccurrences = _ref.maxOccurrences,
    maxOccurrenceDays = _ref.maxOccurrenceDays;
  cov_ox2ey727x().f[4]++;
  cov_ox2ey727x().s[9]++;
  return function (dispatch) {
    cov_ox2ey727x().f[5]++;
    cov_ox2ey727x().s[10]++;
    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadAction());
    var params = (cov_ox2ey727x().s[11]++, {
      maxPerformances: maxOccurrences,
      maxTimeslots: maxOccurrences,
      maxPerformanceDays: maxOccurrenceDays,
      maxTimeslotDays: maxOccurrenceDays,
      includeMetadata: true,
      productOwnerNumber: config.productOwnerNumber
    });
    var urlPath = (cov_ox2ey727x().s[12]++, "".concat(config.restHost, "/v1/").concat((cov_ox2ey727x().b[2][0]++, config.config) && (cov_ox2ey727x().b[2][1]++, config.config.cfcacheEnabled) ? (cov_ox2ey727x().b[1][0]++, 'secure/') : (cov_ox2ey727x().b[1][1]++, ''), "catalog"));
    cov_ox2ey727x().s[13]++;
    if ((cov_ox2ey727x().b[4][0]++, config.config) && (cov_ox2ey727x().b[4][1]++, config.config.cachedCatalogEnabled)) {
      cov_ox2ey727x().b[3][0]++;
      cov_ox2ey727x().s[14]++;
      params = {};
      cov_ox2ey727x().s[15]++;
      urlPath = "".concat(config.restHost, "/v1/catalog/shared");
    } else {
      cov_ox2ey727x().b[3][1]++;
    }
    var requestUrl = (cov_ox2ey727x().s[16]++, (0, _utils.buildUrl)(urlPath, params));
    // then fetch the catalog
    cov_ox2ey727x().s[17]++;
    return (0, _gAxios.default)(requestUrl, {
      headers: config.headers
    }).then(function (response) {
      cov_ox2ey727x().f[6]++;
      cov_ox2ey727x().s[18]++;
      if ((cov_ox2ey727x().b[6][0]++, response.status >= 200) && (cov_ox2ey727x().b[6][1]++, response.status < 300)) {
        cov_ox2ey727x().b[5][0]++;
        var successActionToCall;
        // the load action allows to define if we want to merge all the sections in one section with a cluster by day
        cov_ox2ey727x().s[19]++;
        if (byDay) {
          cov_ox2ey727x().b[7][0]++;
          cov_ox2ey727x().s[20]++;
          successActionToCall = getLoadCalendarSuccessAction;
        } else {
          cov_ox2ey727x().b[7][1]++;
          cov_ox2ey727x().s[21]++;
          // default action to follow the section configuration
          successActionToCall = getLoadSuccessAction;
        }
        cov_ox2ey727x().s[22]++;
        dispatch(successActionToCall(response.data, config));
        cov_ox2ey727x().s[23]++;
        return response.data;
      } else {
        cov_ox2ey727x().b[5][1]++;
      }
      cov_ox2ey727x().s[24]++;
      throw response;
    }).catch(function (response) {
      cov_ox2ey727x().f[7]++;
      cov_ox2ey727x().s[25]++;
      dispatch(getLoadErrorAction());
      cov_ox2ey727x().s[26]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_ox2ey727x().s[27]++;
      return response;
    });
  };
};
var _default = exports.default = {
  load: load
};